// extracted by mini-css-extract-plugin
export var base = "_32-0";
export var updateBanner = "_32-1";